var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Circle, Path } from "react-native-svg";
function SvgPlayCircled(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.67 26.67"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 13.33,
    cy: 13.33,
    r: 12.88,
    stroke: "#e00b7e",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M20.12 14.33c.95-.55.95-1.45 0-2l-9.87-5.69c-.95-.55-1.73-.1-1.73 1v11.4c0 1.1.78 1.55 1.73 1l9.87-5.7z",
    fill: "#e00b7e"
  }))));
}
export default SvgPlayCircled;